export default __webpack_public_path__ + "static/media/movie_play.860cef8a.png";